import React, { useState,useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Divider,
  Grid,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
// import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const validatePassword = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return (
    password.length >= minLength &&
    hasUpperCase &&
    hasLowerCase &&
    hasSpecialChar
  );
};

const TCInfiniteLogin = () => {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const [error, setError] = useState("");

  //   const navigate = useNavigate();

  const [ShowDialog, setShowDialog] = useState(false);

  const Closedialog = () => setShowDialog(false);

  const getIpAddress = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json");
      return response.data.ip;
    } catch (error) {
      console.error("Error fetching IP address", error);
      return null;
    }
  };

  const getUserAgent = () => {
    return navigator.userAgent;
  };

  const [urlParams, setUrlParams] = useState({});

  useEffect(() => {
    const url = new URL(window.location.href);
    const params = Object.fromEntries(url.searchParams.entries());

    setUrlParams(params);
  }, []);

  //============================================================

  //   function getDeviceInfo() {
  //     const userAgent = navigator.userAgent;
  //     let deviceName = "Unknown Device";

  //     // Check for various devices based on user agent string
  //     if (/iPhone|iPad|iPod/i.test(userAgent)) {
  //       deviceName = "Apple iOS Device";
  //     } else if (/Android/i.test(userAgent)) {
  //       deviceName = "Android Device";
  //     } else if (/Windows NT/i.test(userAgent)) {
  //       deviceName = "Windows Device";
  //     } else if (/Macintosh/i.test(userAgent)) {
  //       deviceName = "MacOS Device";
  //     } else if (/Linux/i.test(userAgent)) {
  //       deviceName = "Linux Device";
  //     }

  //     return deviceName;
  //   }

  //function to handle user Login
  //   const handleLogin = async () => {
  //     const device = getDeviceInfo();
  //     setMessage("");
  //     setLoading(true);

  //     try {
  //       const { data } = await axios.post(
  //         `${process.env.REACT_APP_API_URL}/auth/login`,
  //         {
  //           userEmail: userEmail,
  //           password,
  //           device,
  //         }
  //       );
  //       // console.log("Data ", data);

  //       if (data.Sub === "m") {
  //         localStorage.setItem("token", data.token);
  //         navigate("/Member/ShraddhaEvents");
  //       } else if (data.Sub === "n") {
  //         localStorage.setItem("guestToken", data.guestToken);
  //         navigate("/Gauest/GauestEvents");
  //       } else {
  //         alert("Access Denied ! Please Contact +91 020 41488999");
  //       }
  //     } catch (error) {
  //       setMessage(
  //         error.response?.data?.message || error.message || "An error occurred"
  //       );
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //=========================================================
  
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleRegister(e);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const valid = validatePassword(password);
    setIsValid(valid);

    if (!valid) {
      return;
    }

    if (!termsChecked) {
      setError("You must agree to the terms and conditions");
      return;
    }

    setLoading(true);
    setMessage("");

    const ipAddress = await getIpAddress();
    const userAgent = getUserAgent();

    // console.log("Ip and Agent", ipAddress, userAgent);

    try {
      await axios.post(process.env.REACT_APP_API_URL + "/auth/registration", {
        ipAddress,
        userAgent,
      });
      //   handleLogin();
    } catch (error) {
      console.log("During Registration", error);
    }
  };

  const handleCheckboxChange = (event) => {
    setTermsChecked(event.target.checked);
    setError("");
  };
  const handleClickTc = () => {
    setShowDialog(true);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundImage: "url('../../assets/sign up BG_equal.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        flexDirection: "column",
      }}
    >
      {/* ========================================================== */}

      <Dialog
        open={ShowDialog}
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: "#f0f0f0",
            // padding: 2,
          },
        }}
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                color: "black",
                marginBottom: "20px",
                alignItems: "center",
                fontWeight: "bolder",
              }}
            >
              Terms and Conditions
            </Typography>
          </Box>
          <Box
            sx={{
              maxHeight: 390,
              overflowY: "auto",
              padding: 2,
              backgroundColor: "#fff",
              borderRadius: 1,
              border: "1px solid #ccc",
            }}
          >
            <Typography variant="body2" sx={{ color: "black" }}>
              Welcome to Shraddha Infinite ("the Platform"). These Terms and
              Conditions ("Terms") govern your access to and use of the Platform
              and its services. By registering an account or using the Platform,
              you agree to be bound by these Terms. If you do not agree, please
              refrain from using the Platform.
              <br />
              <br />
              <strong>1. Eligibility</strong>
              <br />
              To use Shraddha Infinite, you must be at least 18 years old and
              capable of entering into a legally binding agreement. By signing
              up, you confirm that the information provided is accurate and
              complete.
              <br />
              <br />
              <strong>2. Account Registration</strong>
              <br />
              You are required to provide the following information during
              registration:
              <ul>
                <li>First Name</li>
                <li>Last Name</li>
                <li>Email ID</li>
                <li>Mobile Number</li>
                <li>Company Name</li>
                <li>Password</li>
              </ul>
              Your password is encrypted and securely stored. You are
              responsible for maintaining the confidentiality of your login
              credentials. Sharing or transferring your login details to third
              parties is strictly prohibited.
              <br />
              <br />
              <strong>3. Membership and Paid Services</strong>
              <br />
              Shraddha Infinite offers access to membership content, including
              but not limited to online events, training videos, and support
              services. Membership is a paid service, and all fees are
              non-refundable. By subscribing, you agree to make timely payments
              as per the selected plan.
              <br />
              <br />
              <strong>4. Prohibited Activities</strong>
              <br />
              You agree not to engage in the following activities:
              <ul>
                <li>Sharing, transferring, or misusing login credentials.</li>
                <li>
                  Accessing, distributing, or copying membership content without
                  authorization.
                </li>
                <li>Violating any applicable laws or regulations.</li>
              </ul>
              Shraddha Infosystems reserves the right to terminate your account
              without notice if these activities are detected.
              <br />
              <br />
              <strong>5. Intellectual Property</strong>
              <br />
              All content available on the Platform, including but not limited
              to videos, text, and graphics, is the exclusive property of
              Shraddha Infosystems. Unauthorized use, reproduction, or
              distribution is strictly prohibited.
              <br />
              <br />
              <strong>6. Data Collection and Privacy</strong>
              <br />
              Shraddha Infinite collects and processes user data, including the
              information provided during registration, to deliver its services.
              By using the Platform, you consent to this data being used in
              compliance with our Privacy Policy.
              <br />
              We do not share your personal data with third parties except for
              essential service providers, such as payment processors.
              <br />
              <br />
              <strong>7. Disclaimers and Limitations of Liability</strong>
              <br />
              <ul>
                <li>
                  The Platform and its services are provided "as is" without
                  warranties of any kind, either express or implied.
                </li>
                <li>
                  Shraddha Infinite is not liable for any indirect, incidental,
                  or consequential damages arising from your use of the
                  Platform.
                </li>
                <li>
                  While we strive to provide uninterrupted service, we do not
                  guarantee that the Platform will be available at all times or
                  free from errors.
                </li>
              </ul>
              <br />
              <br />
              <strong>8. Termination</strong>
              <br />
              Shraddha Infosystems reserves the right to suspend or terminate
              your account if you violate these Terms. Upon termination, your
              access to membership content will be revoked without refund.
              <br />
              <br />
              <strong>9. Governing Law</strong>
              <br />
              These Terms are governed by the laws of India. Any disputes
              arising from these Terms will be subject to the exclusive
              jurisdiction of the courts in Pune, India.
              <br />
              <br />
              <strong>10. Modifications to the Terms</strong>
              <br />
              Shraddha Infosystems may revise these Terms at any time by
              updating this page. Continued use of the Platform after changes
              are made constitutes your acceptance of the revised Terms.
              <br />
              <br />
              Contact Us For any questions or concerns about these Terms, please
              contact us at 02041488999.
              <br />
              <br />
              By registering for an account and using the Platform, you
              acknowledge that you have read, understood, and agreed to these
              Terms and Conditions.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{ display: "flex", justifyContent: "right", padding: 1 }}
        >
          <Button
            size="small"
            variant="contained"
            onClick={Closedialog}
            sx={{ borderRadius: "10px", background: "black" }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      {/* ==================== Add marquee text====================================== */}
      <Box
        sx={{
          backgroundColor: "black",
          color: "white",
          width: "100%",
          display: "flex",
          alignItems: "center",
          paddingBottom: "10px",
          position: "fixed",
          top: 0,
          height: "5vh",
          marginTop: "10px",
          animation: "marquee 50s linear infinite",
          "@keyframes marquee": {
            "0%": { transform: "translateX(100%)" },
            "100%": { transform: "translateX(-100%)" },
          },
        }}
      >
        <Button
          variant="contained"
          size="small"
          sx={{
            mt: "2px",
            mr: 2,
            backgroundColor: "#B09246",
            ":hover": { backgroundColor: "#B09246" },
            borderRadius: "10px",
          }}
          onClick={() =>
            window.open(
              "https://shraddhainfosystems.od2.vtiger.com/appointments/bookfreeconsultation"
            )
          }
        >
          Book Demo
        </Button>
        <Typography sx={{ whiteSpace: "nowrap", color: "white" }}>
          FREE Shraddha Infinite Tally BackUp on Google Drive for 6 Months
        </Typography>
        <Button
          variant="contained"
          size="small"
          sx={{
            mt: "2px",
            ml: 2,
            backgroundColor: "#B09246",
            ":hover": { backgroundColor: "#B09246" },
            borderRadius: "10px",
          }}
          onClick={() =>
            window.open(
              "https://shraddhainfosystems.od2.vtiger.com/appointments/bookfreeconsultation"
            )
          }
        >
          Book Demo
        </Button>
      </Box>

      {/* =============================================  */}

      <Paper
        elevation={3}
        sx={{
          display: "flex",
          flexDirection: "column",
          width: {
            xs: "300px",
            sm: "300px",
            md: "400px",
            lg: "400px", // Increased height for larger screens
            xl: "400px", // Extra large screens
          }, //"",
          padding: {
            xs: "20px",
            sm: "20px",
            md: "20px",
            lg: "20px", // Increased height for larger screens
            xl: "20px", // Extra large screens
          },
          borderRadius: "10px",
          //   backgroundColor: "#ebfafc",
          mt: 4,
        }}
      >
        <Typography
          variant="h4"
          align="center"
          sx={{ color: "#000", marginBottom: "30px", margin: "0", p: "0" }}
        >
          <img
            alt="logo"
            width="250px"
            height="120px"
            style={{ borderRadius: "15px" }}
            src="../../assets/Infinitelogo.png"
          />
        </Typography>

        <Divider style={{ margin: "10px 0" }} />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              name="Company GSTIN"
              label="Cmp GSTIN"
              variant="outlined"
              fullWidth
              size="small"
              value={urlParams.GSTNumber}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              name="Tally Serial Number"
              label="Tally Serial No"
              variant="outlined"
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              value={urlParams.SerialNo}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="Tally Release version"
              label="Tally Release version"
              variant="outlined"
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              value={urlParams.Release}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="Tally valid Till Date"
              label="Tally valid Till Date"
              variant="outlined"
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              value={urlParams.expireDate}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              name="password"
              label="Password"
              variant="outlined"
              type={showPassword ? "text" : "password"}
              fullWidth
              required
              size="small"
              value={password}
              onKeyDown={handleKeyDown} 
              onChange={(e) => setPassword(e.target.value)}
              error={isValid === false}
              helperText={
                isValid === false
                  ? "Password must be at least 8 characters, including uppercase, lowercase, and special characters."
                  : ""
              }
              disabled={loading}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      sx={{ color: "black" }}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" flexDirection="row" alignItems="center">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={termsChecked}
                    onChange={handleCheckboxChange}
                    size="small"
                    sx={{
                      color: "#000",
                      "&.Mui-checked": {
                        color: "#000",
                      },
                    }}
                  />
                }
                label=""
                sx={{
                  color: "#000",
                  "&.Mui-checked": {
                    color: "#000",
                  },
                }}
              />
              <Typography
                sx={{ color: "#000", cursor: "pointer" }}
                onClick={handleClickTc}
              >
                Terms and Conditions
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {error && (
          <Grid item xs={12}>
            <Typography color="error">{error}</Typography>
          </Grid>
        )}

        {message && (
          <Typography color="error" align="center" sx={{ marginTop: 1 }}>
            {message}
          </Typography>
        )}

        <Button
          variant="contained"
          fullWidth
          sx={{
            marginTop: "15x",
            backgroundColor: "#B09246",
            ":hover": { backgroundColor: "#B09246" },
            borderRadius: "10px",
          }}
          onClick={handleRegister}
          disabled={loading}
        >
          {loading ? "Registering..." : "Register"}
        </Button>

        <Divider style={{ margin: "10px 0" }} />

        <Box display="flex" justifyContent="space-between">
          <Typography variant="h5" sx={{ color: "#000", m: "0", p: "0" }}>
            Already have an account?{" "}
            <Link to="/Auth/" style={{ textDecoration: "none" }}>
              <Typography
                variant="body2"
                sx={{ color: "blue", display: "inline" }}
              >
                Log in
              </Typography>
            </Link>
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default TCInfiniteLogin;
